export const SMS_BALANCE_HISTORY = 'SMS_BALANCE_HISTORY'
export const FETCH_ALL_BALANCE_DATA = 'FETCH_ALL_BALANCE_DATA'
export const EMAIL_BALANCE_HISTORY = 'EMAIL_BALANCE_HISTORY'
